import React from "react";
import { Box, Typography, Container, Grid, Paper } from "@mui/material";
import CustomButtonComponent from "../../../core/custom-button";
import ENGINE_PARTS_IMG from "../../../resources/images/engine-parts.png";
import LUBRICANTS_IMG from "../../../resources/images/lubricants.png";

const PartsCatalouge = () => {
  const handleButtonClick = () => {
    window.open(
      "https://simparts.simpsons.in/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Box
      sx={{
        minHeight: "90vh",
        background:
          "linear-gradient(135deg,rgb(245, 245, 245) 0%,rgb(236, 240, 244) 100%)",
        position: "relative",
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2, py: 2 }}>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            mb: 2,
            color: "#002060",
          }}
        >
          Parts Catalogue
        </Typography>

        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            mb: 3,
            color: "#555",
          }}
        >
          Explore a wide range of high-quality spare parts and lubricants for
          your machinery.
        </Typography>
        <Box sx={{ textAlign: "center" }}>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            size="large"
            onClick={handleButtonClick}
            sx={{
              px: 3,
              py: 1,
              fontSize: "1.2rem",
              mb: 6,
              background: "#002060",
            }}
          >
            Go To Parts Catalogue
          </CustomButtonComponent>
        </Box>
        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                p: 1,
                background: "white",
                borderRadius: 2,
              }}
            >
              <Box
                component="img"
                src={ENGINE_PARTS_IMG}
                alt="Engine Components"
                sx={{
                  width: "100%",
                  height: "300px",
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h5"
                sx={{ color: "#002060", textAlign: "center", mb: 3 }}
              >
                Engine Components
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                p: 1,
                background: "white",
                borderRadius: 2,
              }}
            >
              <Box
                component="img"
                src={LUBRICANTS_IMG}
                alt="Lubricants and Fluids"
                sx={{
                  width: "100%",
                  height: "300px",
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h5"
                sx={{ color: "#002060", textAlign: "center", mb: 3 }}
              >
                Lubricants & Fluids
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PartsCatalouge;
